import { Action } from '@ngrx/store';
import {
  EmployeeEquipmentWorkflowInterface,
  EmployeeEquipmentWorkflowStatusInterface,
  EquipmentCategoryInterface,
  EquipmentInterface } from 'app/equipment/models';

import { EquipmentActionType } from './equipment-action-type.enum';

export class UpdateEquipmentCategory implements Action {
  public readonly type: EquipmentActionType = EquipmentActionType.UpdateEquipmentCategory;

  constructor(public readonly payload: EquipmentCategoryInterface) { }
}

export class UpdateEquipmentCategoryCompleted implements Action {
  public readonly type: EquipmentActionType = EquipmentActionType.UpdateEquipmentCategoryCompleted;

  constructor(public readonly payload: EquipmentCategoryInterface) { }
}

export class UpdateEquipmentCategoryFailed implements Action {
  public readonly type: EquipmentActionType = EquipmentActionType.UpdateEquipmentCategoryFailed;

  constructor(public readonly payload: string) { }
}

export class UpdateEquipmentLibraryItem implements Action {
  public readonly type: EquipmentActionType = EquipmentActionType.UpdateEquipmentLibraryItem;

  constructor(public readonly payload: EquipmentInterface) { }
}

export class UpdateEquipmentLibraryItemCompleted implements Action {
  public readonly type: EquipmentActionType = EquipmentActionType.UpdateEquipmentLibraryItemCompleted;

  constructor(public readonly payload: EquipmentInterface) { }
}

export class UpdateEquipmentLibraryItemFailed implements Action {
  public readonly type: EquipmentActionType = EquipmentActionType.UpdateEquipmentLibraryItemFailed;

  constructor(public readonly payload: string) { }
}

export class UpdateEmployeeEquipmentItem implements Action {
  public readonly type: EquipmentActionType = EquipmentActionType.UpdateEmployeeEquipmentItem;

  constructor(public readonly payload: EmployeeEquipmentWorkflowInterface) { }
}

export class UpdateEmployeeEquipmentItemCompleted implements Action {
  public readonly type: EquipmentActionType = EquipmentActionType.UpdateEmployeeEquipmentItemCompleted;

  constructor(public readonly payload: EmployeeEquipmentWorkflowInterface) { }
}

export class UpdateEmployeeEquipmentItemFailed implements Action {
  public readonly type: EquipmentActionType = EquipmentActionType.UpdateEmployeeEquipmentItemFailed;

  constructor(public readonly payload: string) { }
}

export class UpdateEmployeeEquipmentWorkFlowStatus implements Action {
  public readonly type: EquipmentActionType = EquipmentActionType.UpdateEmployeeEquipmentWorkFlowStatus;

  constructor(public readonly payload:
    { workflow: EmployeeEquipmentWorkflowInterface, statusRecord: EmployeeEquipmentWorkflowStatusInterface }) { }
}

export class UpdateEmployeeEquipmentWorkFlowStatusCompleted implements Action {
  public readonly type: EquipmentActionType = EquipmentActionType.UpdateEmployeeEquipmentWorkFlowStatusCompleted;

  constructor(public readonly payload: EmployeeEquipmentWorkflowInterface) { }
}

export class UpdateEmployeeEquipmentWorkFlowStatusFailed implements Action {
  public readonly type: EquipmentActionType = EquipmentActionType.UpdateEmployeeEquipmentWorkFlowStatusFailed;

  constructor(public readonly payload: string) { }
}
